module.exports = __webpack_public_path__ + "img/img_zw.ae6ae9a3.png";